import { all, fork } from 'redux-saga/effects';

// Import sagas
import canvas from './canvas';
import control from './control';
import dataProviderTranslation from './dataProviderTranslation';
import desktopApp from './desktopApp';
import graphic from './graphic';
import graphicPackage from './graphicPackage';
import matchControl from './matchControl';
import mediaLibrary from './mediaLibrary';
import notification from './notification';
import output from './output';
import playlist from './playlist';
import bundledPlaylistGraphic from './bundledPlaylistGraphic';
import playlistGraphic from './playlistGraphic';
import rundown from './rundown';
import rundownTemplate from './rundownTemplate';
import sportData from './sportData';
import user from './user';
import workspace from './workspace';
import mos from './mos';

// Export root saga
export default function* root() {
  yield all([
    fork(canvas),
    fork(graphic),
    fork(control),
    fork(desktopApp),
    fork(graphicPackage),
    fork(output),
    fork(playlist),
    fork(bundledPlaylistGraphic),
    fork(playlistGraphic),
    fork(rundown),
    fork(rundownTemplate),
    fork(user),
    fork(mediaLibrary),
    fork(notification),
    fork(matchControl),
    fork(sportData),
    fork(dataProviderTranslation),
    fork(workspace),
    fork(mos),
  ]);
}
